export default __webpack_public_path__ + "static/media/Bangles-Making-Charge-List.a3eb9e4a.jpg";